import { defineComponent as _defineComponent } from 'vue'
import DateUtils from '@/services/utils/DateUtils';
import moment from 'moment/moment';
import {QuizCategory} from '@/models/Quiz';
import LTimerPill from '@/components/commons/LTimerPill.vue';
import {CreatedPartnerModel} from '@/models/Partner';
import {QuizTestAttempt} from '@/modules/bhp/models/QuizTest';
type QuizInfoConfigSuccess = {
  successDescription: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QuizCardSuccess',
  props: {
    lastPositiveAttempt: null,
    quizCategory: null
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: emits }: { emit: ({(e: 'closeModal', partner?: CreatedPartnerModel): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  lastPositiveAttempt: QuizTestAttempt,
  quizCategory: QuizCategory
};




const quizInfoConfig: Partial<Record<QuizCategory,QuizInfoConfigSuccess>> = {
  [QuizCategory.STMT]: {
    successDescription: `Wymóg potwierdzenia oświadczenia akredytacyjnego odnowi się za ${moment(props.lastPositiveAttempt.allowReattemptAt).diff(moment(), 'days')} dni.`,
  },
  [QuizCategory.ETHIC]: {
    successDescription: `Wymóg szkolenia odnowi się za ${moment(props.lastPositiveAttempt.allowReattemptAt).diff(moment(), 'days')} dni.`,
  },
  [QuizCategory.BANK_STMTS]: {
    successDescription: `Wymóg potwierdzenia oświadczenia bankowego odnowi się za ${moment(props.lastPositiveAttempt.allowReattemptAt).diff(moment(), 'days')} dni.`,
  },
  [QuizCategory.KNF]: {
    successDescription: `Wymóg zdania oświadczenia KNF odnowi się za ${moment(props.lastPositiveAttempt.allowReattemptAt).diff(moment(), 'days')} dni.`,
  },
}

  

return { __sfc: true,emits, props, quizInfoConfig, DateUtils, moment, LTimerPill }
}

})